// Styles
import styles from "components/organisms/SideNavigation/SideNavigation.module.css";

// Components
import Logo from "components/atoms/CompanyLogo/Logo";
import SideNavigationMenu from "components/molecules/SideNavigationMenu/SideNavigationMenu";
import Tooltip from "components/atoms/Tooltip/Tooltip";

// Utils
import getIcon, { IconProps } from "utils/getIcon";

// Types
import { To } from "react-router-dom";
import { OutletItem } from "services/api/types";
import { NavigationMenuItem } from "containers/Home/useHome";
import React, { useCallback } from "react";

const Icon = (props: IconProps) => getIcon({ ...props });

type SideNavigationProps = {
	outlets: Array<OutletItem>;
	isAdminUser: boolean;
	open: boolean;
	userDetails: {
		name: string;
		code: string;
	};
	activeMenu: number;
	menusToRender: NavigationMenuItem[];
	handleToggle: () => void;
	handleMenuClick: (menuId: number, redirectedPath: To | To[]) => void;
	handleUsernameClick: () => void;
	hasUserProfileViewPermission: boolean;
};

const SideNavigation = ({
	open,
	userDetails,
	outlets,
	isAdminUser,
	menusToRender,
	activeMenu,
	handleMenuClick,
	handleToggle,
	handleUsernameClick,
	hasUserProfileViewPermission
}: SideNavigationProps): JSX.Element => {
	// Extract keyboard handler to avoid creating new function on every render
	const handleKeyDown = useCallback(
		(e: React.KeyboardEvent) => {
			if (e.key === "Enter" || e.key === " ") {
				e.preventDefault();
				handleUsernameClick();
			}
		},
		[handleUsernameClick]
	);

	const baseClasses = "mt-5 m-auto text-center flex flex-col";
	const userDetailsClasses = hasUserProfileViewPermission ? `${baseClasses} cursor-pointer hover:text-blue-600 transition-colors` : baseClasses;

	return (
		<>
			<button className={styles?.toggle_button} onClick={handleToggle}>
				{open ? <Icon icon="cancel" /> : <Icon icon="menu" />}
			</button>
			<div className={open ? styles.layout_mobile : styles?.layout} data-testid="side-navigation">
				<Logo classes={styles.logo} />
				{hasUserProfileViewPermission ? (
					<Tooltip title="Click to view or update your profile" placement="right">
						<div className={userDetailsClasses} onClick={handleUsernameClick} role="button" tabIndex={0} onKeyDown={handleKeyDown}>
							<span className="font-bold text-base">{userDetails?.name}</span>
							<span>{userDetails?.code?.replace("Admin ID:", "")}</span>
						</div>
					</Tooltip>
				) : (
					<div className={userDetailsClasses}>
						<span className="font-bold text-base">{userDetails?.name}</span>
						<span>{userDetails?.code?.replace("Admin ID:", "")}</span>
					</div>
				)}
				<SideNavigationMenu isAdminUser={isAdminUser} activeMenu={activeMenu} menusToRender={menusToRender} outlets={outlets} handleMenuClick={handleMenuClick} />
			</div>
		</>
	);
};

export default SideNavigation;
